// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb-module--breadcrumb--3fffd","active":"Breadcrumb-module--active--5e443"};